import { Injectable } from "@angular/core";
import { ApiResourceService } from "../../apiResource/apiResource.service";
import { Observable } from "rxjs";
import {
    IDashboardConfig,
    IDashboardSearchParameter,
    ISearchParameterResponse
} from "libraries/interfaces/i-dashboard-config";

const DASHBOARD: string = "dashboard";
const GET_FILTER: string = "getFilters";
const SEARCH: string = "search";

export interface IDashboardRequestUrlParts extends ISearchParameterResponse{
    req?: string;
    type?: string;
    index?: string;
}

export interface IGetFilterResponse {
    [key: string]: string[];
}

@Injectable()
export class DashboardResourceService {
    constructor(
        private readonly apiResource: ApiResourceService,
    ) {
    }

    public search(request: IDashboardRequestUrlParts): Observable<any> {
        return this.apiResource.getOne(
            this.apiResource.getApiUrl(DASHBOARD, SEARCH),
            request,
        );
    }

    public getFilters(request: IDashboardRequestUrlParts): Observable<IGetFilterResponse> {
        return this.apiResource.getOne(
            this.apiResource.getApiUrl(DASHBOARD, GET_FILTER),
            request
        );

    }
}
